import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=fb1bead2&scoped=true"
import script from "./UsersNew.vue?vue&type=script&lang=js"
export * from "./UsersNew.vue?vue&type=script&lang=js"
import style0 from "./UsersNew.vue?vue&type=style&index=0&id=fb1bead2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1bead2",
  null
  
)

export default component.exports